import SocShare from './SocShare'
import './SocShare.css'
import './ya.css'

export default SocShare



// WEBPACK FOOTER //
// ./src/components/SocShare/index.js